import React, { PureComponent, createRef } from 'react';

import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';

import { USER_TAB } from 'constants/form';

import CreateStudent from './user';
import CreateProfile from './profile';
import { FORM_ACTIONS, PII_HIDDEN_FORM_ACTIONS } from '../../constants/form';

const FullFlexView = styled(FlexView)`
  width: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
`;

const Progress = styled.div`
  width: ${({ width }) => width}%;
  height: 5px;
  background-color: blue;
  margin-bottom: 30px;
  transition: width 1s;
`;

const RefElement = styled.div`
  width: 0;
  height; 0;
`;

export default class StudentFormView extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollRef = createRef();
  }

  componentDidUpdate() {
    this.scrollRef.current.scrollIntoView({ block: 'start' });
  }

  renderForm = () => {
    switch (this.props.tab) {
      case USER_TAB.ACCOUNT: {
        if (PII_HIDDEN_FORM_ACTIONS.includes(this.props.formType)) {
          const newStudent = { ...this.props.student, email: '' };
          return <CreateStudent {...this.props} student={newStudent} />;
        } else return <CreateStudent {...this.props} />;
      }
      case USER_TAB.PROFILE:
        return <CreateProfile {...this.props} />;
      default:
        return null;
    }
  };

  render() {
    const { tab } = this.props;
    const progressBarWidth = ((tab + 1) * 100) / (Object.keys(USER_TAB).length - 1);

    return (
      <FullFlexView>
        <RefElement ref={this.scrollRef} />
        <CardWrapper>
          <Progress width={progressBarWidth} />
          {this.renderForm()}
        </CardWrapper>
      </FullFlexView>
    );
  }
}
